import { useEffect, useState } from "react";
import NumberFormat from "react-number-format";

const TextboxMask = ({
  id,
  name,
  register,
  errors,
  title,
  value,
  setValue,
  optional,
  format,
  mask,
  ...rest
}) => {
  const [formattedValue, setFormattedValue] = useState();

  const handleChange = (e) => {
    setValue(name, e.formattedValue);
    setFormattedValue(e.formattedValue);
  };

  useEffect(() => {
    setValue(name, value);
    setFormattedValue(value);
  }, [value, name, setValue]);

  return (
    <>
      {title && (
        <label className="form-label" htmlFor={id}>
          {title}
          {optional && (
            <span className="text-xs ml-2 text-gray-300">Optional</span>
          )}
        </label>
      )}
      <NumberFormat
        id={id}
        name={name}
        mask={mask}
        format={format}
        onValueChange={handleChange}
        value={formattedValue}
        className={`form-control ${errors && errors[name] && "form-invalid"}`}
        {...register}
        {...rest}
      />
      {errors && errors[name] && (
        <div className="pt-2">
          <span className="text-sm text-red-400">{errors[name].message}</span>
        </div>
      )}
    </>
  );
};

export default TextboxMask;
